export default "__VITE_ASSET__Cn9F2U4s__"